<app-base-inline-form [fields]="fields" [model]="model"></app-base-inline-form>

<div #reportContent>
  @if (selectedReport) {
    <ng-template [ngTemplateOutlet]="selectedReport.template"></ng-template>
  }
</div>
